module.exports = __webpack_public_path__ + "media/images/icons/filter-menu-open-86b764b27c9b1f28082f54cceb7f5702.svg";